// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/chat/:profileExternalId\",\"regex\":\"^/chat/([^/]+)$\",\"paramNames\":[\"profileExternalId\"]},{\"path\":\"/create-patient/:returnTo\",\"regex\":\"^/create-patient/([^/]+)$\",\"paramNames\":[\"returnTo\"]},{\"path\":\"/debug/:hash\",\"regex\":\"^/debug/([^/]+)$\",\"paramNames\":[\"hash\"]},{\"path\":\"/debug/launch/:persona\",\"regex\":\"^/debug/launch/([^/]+)$\",\"paramNames\":[\"persona\"]},{\"path\":\"/messages/:profileExternalId/:childId/:visitId\",\"regex\":\"^/messages/([^/]+)/([^/]+)/([^/]+)$\",\"paramNames\":[\"profileExternalId\",\"childId\",\"visitId\"]},{\"path\":\"/new-visit/:profileExternalId/:childId\",\"regex\":\"^/new-visit/([^/]+)/([^/]+)$\",\"paramNames\":[\"profileExternalId\",\"childId\"]},{\"path\":\"/visit-details/:profileExternalId/:childId/:visitId\",\"regex\":\"^/visit-details/([^/]+)/([^/]+)/([^/]+)$\",\"paramNames\":[\"profileExternalId\",\"childId\",\"visitId\"]}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/auth\"},{\"path\":\"/chat-return\"},{\"path\":\"/debug\"},{\"path\":\"/debug/playbook\"},{\"path\":\"/debug/playbook/child\"},{\"path\":\"/debug/playbook/home/visit-list\"},{\"path\":\"/debug/playbook/ui\"},{\"path\":\"/debug/playbook/ui/avatar\"},{\"path\":\"/debug/playbook/ui/colors\"},{\"path\":\"/debug/playbook/ui/typography\"},{\"path\":\"/debug/provider\"},{\"path\":\"/debug/push-notifications\"},{\"path\":\"/debug-blueberry-visit\"},{\"path\":\"/error\"},{\"path\":\"/home\"},{\"path\":\"/past-visits\"}]}";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  _experiments: { enableLogs: true },

  // Add optional integrations for additional features
  integrations: [
    Sentry.consoleLoggingIntegration({ levels: ["log", "error", "warn"] }),

    Sentry.replayIntegration(),
  ],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
